 
import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useUserApi() {
  const callApi = useApiCall();

  const login = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.LOGIN, data, onSuccess, onError);
  };
  const logout = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.LOGOUT, data, onSuccess, onError);
  };
  const register = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.REGISTER, data, onSuccess, onError);
  };
  const forgotPassword = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.FORGET_PASSWORD, data, onSuccess, onError);
  };
  const resetPassword = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.RESET_PASSWORD, data, onSuccess, onError);
  };
  const getDesigns = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.GET_DESIGNS, data, onSuccess, onError);
  };
  const saveDesign = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.SAVE_DESIGN, data, onSuccess, onError);
  };
  const updateDesign = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.UPDATE_DESIGN, data, onSuccess, onError);
  };

  const getImages = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.IMAGE_LIST, data, onSuccess, onError);
  };
  const uploadImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.IMAGE_UPLOAD, data, onSuccess, onError);
  }; 
  const deleteImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.IMAGE_DELETE, data, onSuccess, onError);
  }; 


  const saveTeamUserMapping = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.SAVE_TEAM_USER_MAPPING, data, onSuccess, onError);
  };


  // New API endpoint: APIAuthenticate/GetAllApiEndpoints
  const getAllApiEndpoints = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.GET_ALL_API_ENDPOINTS, data, onSuccess, onError);
  };

  // New API endpoint: APIAuthenticate/SaveUserModuleBundle
  const saveUserModuleBundle = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.SAVE_USER_MODULE_BUNDLE, data, onSuccess, onError);
  };
  const saveUserModule = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.SAVE_USER_MODULE, data, onSuccess, onError);
  };

  //User module
  const deleteUserModule = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.DELETE_USER_MODULE, data, onSuccess, onError);
  };

  //User type
  const getUserTypeByID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.GET_USER_TYPE_BY_ID, data, onSuccess, onError);
  };
  const getUserTypes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.GET_USER_TYPES, data, onSuccess, onError);
  };
  const saveUserType = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.SAVE_USER_TYPE, data, onSuccess, onError);
  };
  const deleteUserType = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.DELETE_USER_TYPE, data, onSuccess, onError);
  };
  const loginWithPermissions = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.LoginWithPermissions, data, onSuccess, onError);
  };

  //User
  const saveUser = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.SAVE_USER, data, onSuccess, onError);
  };
  const getUser = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.GET_USER, data, onSuccess, onError);
  };
  const getUserModules = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.GET_USER_MODULES, data, onSuccess, onError);
  };
  const getUserModuleByID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.GET_USER_MODULE_BY_ID, data, onSuccess, onError);
  };
  const saveUserModuleApiEntity = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.SAVE_USER_MODULE_API_ENTITY, data, onSuccess, onError);
  };
  const deleteUser = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.USER.DELETE_USER, data, onSuccess, onError);
  };

  return {
    login,
    logout,
    register,
    forgotPassword,
    resetPassword,
    getDesigns,
    saveDesign,
    updateDesign,

    getImages,
    uploadImage, 
    deleteImage,
    saveTeamUserMapping,
    getAllApiEndpoints,
    saveUserModuleBundle,
    saveUserModule,
    deleteUserModule,
    loginWithPermissions,

    getUserTypeByID,
    getUserTypes,
    saveUserType,
    deleteUserType,
    saveUser,
    getUser,
    getUserModules,
    getUserModuleByID,
    saveUserModuleApiEntity,
    deleteUser
  };
}
